export const easyClockEditUrlFor = (userId: string | undefined): string => 
    `${process.env.REACT_APP_EASYCLOCK_BASE_URL}/users/${userId}/edit`

